import React from "react";
import SEO from "../../components/SEO";

const AffordableLuxury = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <SEO 
        title="Affordable Luxury Sunglasses in India"
        description="Discover affordable luxury sunglasses in India with premium design and comfort."
      />

      <h1>Affordable Luxury Sunglasses in India</h1>

      <p>
        Luxury doesn’t always mean expensive. 
        Mark & Luth brings premium designs at affordable prices.
      </p>
    </div>
  );
};

export default AffordableLuxury;